import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Container, Col, Image, Navbar } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import "./index.scss";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import LoadingSpinner from "lib/LoadingSpinner";
import { getOrgInfo } from "api/organisation";
import { setAppColor } from "helper";
import { fetchApplicationStatus } from "api/status";
import { replaceTokensWithData } from "helper/common";

const StatusTracking = () => {
  const [poweredBy, setPoweredBy] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [logoUrl, setLogoURL] = useState();
  const [htmlContent, setHtmlContent] = useState("");
  const [organisationId, setOrganisationId] = useState("");
  const [isApiResponseReceived, setIsApiResponseReceived] = useState(false);

  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);

  // * Fetching workflow Info
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const { data, status: responseStatus } = await fetchApplicationStatus({
        workflowId: decryptedId?.subWfId,
      });

      setIsApiResponseReceived(true);

      if (responseStatus?.toLowerCase() !== "success") {
        setIsLoading(false);
        return;
      }

      const replacedHtmlData = replaceTokensWithData(
      data?.template?.email_template_body,
      data?.workflow
    );
   
      setHtmlContent(replacedHtmlData);
      setOrganisationId(data?.workflow?.organisation_id);
      setIsLoading(false);
    };

    if (decryptedId?.subWfId) {
      fetchData();
    }
  }, [decryptedId?.subWfId]);

  // * Fetching the Organisation Info
  useEffect(() => {
    if (organisationId) {
      setIsLoading(true);
      getOrgInfo({
        _id: organisationId,
      })
        .then((res) => {
          setAppColor(res?.layout_setting);
          setPoweredBy(res?.white_labeled ? res?.white_labeled : false);

          if (res?.logo) {
            setLogoURL("https://signdesk.in/company/" + res?.logo);
            const list = document.getElementById("favicon_customized");
            list.href = res?.icon
              ? `https://signdesk.in/company/${res?.icon}`
              : "https://signdesk.com/images/favicon.png";
            const titleName = document.getElementById("title-id");
            titleName.innerText = res?.setting?.parent_client_name;
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          toast.error("Unable to fetch organisation info");
          setIsLoading(false);
        });
    }
  }, [organisationId]);

  const tickIcon = `<svg class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="90.818" height="90.818" viewBox="0 0 90.818 90.818">
  <g id="Group_2010" data-name="Group 2010" transform="translate(0 0)">
    <path id="Path_947" data-name="Path 947" d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z" transform="translate(-82.261 -259.55)" opacity="0.1" />
    <path id="Path_948" data-name="Path 948" d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z" transform="translate(-78.77 -256.057)" />
    <path id="Path_949" data-name="Path 949" d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z" transform="translate(-75.825 -251.948)" fill="#fff" />
  </g>
</svg>`;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <ToastContainer />
      {htmlContent ? (
        <div className="bg-forms-two vh-100 bg-no-repeat bg-cover position-relative">
          <Navbar
            expand="lg"
            className="bg-body-tertiary bg-mobile bg-forms-two bg-cover"
          >
            <Container fluid>
              <Navbar.Brand href="#home">
                <Image src={logoUrl} className="client-logo" />
              </Navbar.Brand>
            </Container>
          </Navbar>

          <Container>
            <Row className="error-container-height align-items-center justify-content-center">
              <Col xs={12} md={7} lg={5}>
                <div className="bg-white rounded-3 text-center">
                  <span
                    dangerouslySetInnerHTML={{ __html: htmlContent }}
                  ></span>
                </div>
              </Col>
            </Row>
          </Container>
          {poweredBy && (
            <div className="signdesk_logo mb-1 d-lg-block d-md-block d-sm-none d-xs-none bottom-0 d-flex end-0 position-absolute pe-2 p-4">
              <span className="d-flex">
                <p>Powered by</p>
                <Image src={Signdesk_logo} alt="signDesk_logo" />
              </span>
            </div>
          )}
        </div>
      ) : (
        isApiResponseReceived && (
          <div className="bg-forms-two vh-100 bg-no-repeat bg-cover position-relative">
            <Navbar
              expand="lg"
              className="bg-body-tertiary bg-mobile bg-forms-two bg-cover"
            >
              <Container fluid>
                <Navbar.Brand href="#home">
                  <Image src={logoUrl} className="client-logo" />
                </Navbar.Brand>
              </Container>
            </Navbar>

            <Container>
              <Row className="error-container-height align-items-center justify-content-center">
                <Col xs={12} md={6} lg={4}>
                  <div className="p-3 bg-white rounded-3 text-center">
                    <span dangerouslySetInnerHTML={{ __html: tickIcon }}></span>
                    <p className="m-0 fs-20px fw-bold text-theme py-3 py-lg-4">
                      "Application Submitted Successfully"
                    </p>
                    <p className="m-0 fw-bold pb-3 pb-lg-4">
                      "You will be notified upon successful completion of your
                      journey. Please contact your POC for any questions."
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
            {poweredBy && (
              <div className="signdesk_logo mb-1 d-lg-block d-md-block d-sm-none d-xs-none bottom-0 d-flex end-0 position-absolute pe-2 p-4">
                <span className="d-flex">
                  <p>Powered by</p>
                  <Image src={Signdesk_logo} alt="signDesk_logo" />
                </span>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default StatusTracking;
